module.exports = __webpack_public_path__ + "files/3dfe4322ae6ee5ed8a83ebb143472945.png";